<script setup lang="ts">
import { useMediaQuery } from '@vueuse/core'
import AnalyticsConsentBanner from '@/components/common/AnalyticsConsentBanner.vue'
import DialogHost from '@/components/common/DialogHost.vue'
import { Toaster } from '@/components/ui/sonner'
import { useAppViewport } from '@/composables/useAppViewport'
import { useTheme } from '@/composables'
import { useRealtimeSession } from '@/composables/useRealtimeSession'

useAppViewport()
useRealtimeSession()
const { resolved: resolvedTheme } = useTheme()
// On phones, toasts at the bottom cover the page's own action buttons (and the
// thumb zone), so they drop in from the top there. 600px is Sonner's own
// mobile breakpoint, where it switches to full-width toasts and keeps them
// below the notch (safe-area-inset-top) on its own.
const isPhone = useMediaQuery('(max-width: 600px)')
</script>

<template>
  <div class="app-root">
    <!-- Keyed by path: a new path mounts a fresh page,
         while query-only updates (Browse filters) keep the page alive. -->
    <RouterView v-slot="{ Component, route }">
      <Transition name="page-fade">
        <component :is="Component" :key="route.path" />
      </Transition>
    </RouterView>

    <Toaster
      :position="isPhone ? 'top-center' : 'bottom-center'"
      :theme="resolvedTheme"
      :rich-colors="true"
      :close-button="true"
      :offset="80"
    />

    <DialogHost />
    <AnalyticsConsentBanner />
  </div>
</template>

<style scoped>
.app-root {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 150ms ease;
}
.page-fade-enter-from,
.page-fade-leave-to {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .page-fade-enter-active,
  .page-fade-leave-active {
    transition: none;
  }
}
</style>
